import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Card, Text} from '@gravity-ui/uikit';

import ShareButtons from '../ShareButtons';

import {ShareProps} from './Share.types';
import {getShareInfo, getShareType} from './Share.utils';

import './Share.scss';

export const cnShare = cn('Share');

const Share: FC<ShareProps> = ({stats, results, imageLink, ...props}) => {
    const shareType = getShareType(stats, results);

    const {blockTitle, link, text} = getShareInfo(shareType, props);

    return (
        <section>
            <Card className={cnShare()}>
                <Text variant="subheader-3" className={cnShare('Text')} as="h3">
                    {blockTitle}
                </Text>
                <ShareButtons title={text} url={link} image={imageLink} />
            </Card>
        </section>
    );
};
export default Share;
